import AddNewProductMain from "../components/product/AddNewProductMain";

function AddNewProduct() {
  return <AddNewProductMain />;
}

export default AddNewProduct;
